import React from 'react';
import { Icon, Dropdown, Menu, Modal, notification } from 'antd';
import { withRouter } from "react-router-dom";
import { reduxForm, Field, isDirty } from 'redux-form';
import { pyrollDetailsValidation } from '../../../../utils/Validations/payrollDetailsVallidation';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import { customInput } from '../../../common/custom-input';
import * as actions from '../../../../actions/profileManagementActions';
import { Strings } from '../../../../dataProvider/localize';
import { ADMIN_DETAILS, VALIDATE_STATUS, ACCESS_CONTROL } from '../../../../dataProvider/constant';
import { getStorage, handleFocus, DeepTrim } from '../../../../utils/common';
import { isNumber, isValidABN } from '../../../../utils/Validations/scopeDocValidation';
import "../ProfileStyle.css";
import styles from "../ProfileStyles.module.css";
class PayrollDetailsForm extends React.Component {
    paymentMothod = ['eWAY']
    confirm_bank_ac_no_flag = true
    constructor(props) {
        super(props);
        this.org_user_id = JSON.parse(getStorage(ADMIN_DETAILS)) ? JSON.parse(getStorage(ADMIN_DETAILS)).organisation.id : null;
        this.org_user_name = JSON.parse(getStorage(ADMIN_DETAILS)) ? JSON.parse(getStorage(ADMIN_DETAILS)).user_name : null;
        this.state = {
            hasEditPermission: false,
        }
    }

    // more info
    editMenu = (
        <Menu>
            <Menu.Item onClick={this.handleEditClick}>{Strings.menu_edit_org}</Menu.Item>
        </Menu>
    )


    onSubmit = async (formData) => {
        formData = await DeepTrim(formData);

        formData = { ...formData, 'profile_progress': this.props.profileComplete }

        let staffUserName = false
        if (this.props.userDetails) {
            staffUserName = this.props.userDetails.user_name
        }

        this.props.action.updateUserPayroll(formData, staffUserName)
            .then(flag => {
                notification.success({
                    message: Strings.success_title,
                    description: flag,
                    onClick: () => { },
                    className: 'ant-success'
                });
                this.props.action.getOrgUserProfileDetails(this.props.userId ? this.props.userId : this.org_user_id, staffUserName ? staffUserName : this.org_user_name, null, this.shouldUpdateAuthUser)
            }).catch((error) => {
                if (error.status === VALIDATE_STATUS) {
                    notification.warning({
                        message: Strings.validate_title,
                        description: error && error.data && typeof error.data.message == 'string'
                            ? error.data.message : Strings.generic_validate,
                        onClick: () => { },
                        className: 'ant-success'
                    });
                } else {
                    notification.error({
                        message: Strings.error_title,
                        description: error && error.data && error.data.message && typeof error.data.message == 'string'
                            ? error.data.message : Strings.generic_error,
                        onClick: () => { },
                        className: 'ant-error'
                    });
                }
            });
    }

    componentDidMount() {
        if (this.props.initialValues && this.props.initialValues.is_super_ac === 1) {
            this.setState({
                superfundprovider: 'none'
            })
        } else {
            this.setState({
                superfundprovider: 'block'
            })
        }
        if (this.hasPermission("sf_payroll_details_controller_update_payroll_details")) {
            this.setState({ hasEditPermission: true });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.initialValues.bank_ac_number !== parseInt(this.props.formValues.bank_ac_number)) {
            this.confirm_bank_ac_no_flag = false
        }
        if (this.props.initialValues.bank_ac_number === parseInt(this.props.formValues.bank_ac_number)) {
            this.confirm_bank_ac_no_flag = true
        }
    }

    handleChecked = (e) => {
        console.log(e.target.checked)
        if (!e.target.checked) {
            this.setState({
                superfundprovider: 'block'
            })
        } else {
            this.setState({
                superfundprovider: 'none'
            })
        }
    }

    hasPermission = (permission) => {
        let allowed = false;
        let userPermissions = JSON.parse(getStorage(ACCESS_CONTROL))["userManagement"]
        let accessControl = userPermissions && userPermissions.permissions ? userPermissions.permissions : [];
        let permission_id = accessControl.findIndex(acess => acess.control_name.toLowerCase() === permission.toLowerCase());
        if (permission_id !== -1 || this.props.location.pathname === "/dashboard/profile") {
            allowed = true;
        }

        return allowed;
    }

    render() {
        const { handleSubmit } = this.props;

        return (
            <form onSubmit={handleSubmit(this.onSubmit)
            } >

                {/* Personal Details */}
                <hr className={styles.DetailsDivider}></hr>
                <div className="container-fluid pt-3 py-2">
                    <div className="row align-items-center">
                        <h2 className={`${styles.ProfileLabel} font-weight-bold`}>Payroll Details</h2>
                    </div>
                    <div className="row">
                        <div className="col-3 border-right">
                            <div className={styles.ProfileLabelV2}>ABN / ACN</div>
                            <div>
                                <Field
                                    name="abn"
                                    placeholder={Strings.abn_payrole}
                                    type="text"
                                    id="abn"
                                    validate={this.props.formValues.abn !== undefined && this.props.formValues.abn !== '' ? isValidABN : []}
                                    maxLength="11"
                                    component={customInput}
                                    className={styles.ProfileFormField}
                                    disabled={!this.state.hasEditPermission} />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className={styles.ProfileLabelV2}>TFN</div>
                            <div>
                                <Field
                                    name="tfn"
                                    placeholder={Strings.tfn_payrole}
                                    type="text"
                                    id="tfn"
                                    validate={isNumber}
                                    maxLength="9"
                                    component={customInput}
                                    className={styles.ProfileFormField}
                                    disabled={!this.state.hasEditPermission} />
                            </div>
                        </div>

                    </div>
                    <div className="mt-2">
                        <button type="submit" className={styles.BtnSaveTab} disabled={!this.props.isDirty || !this.hasPermission('sf_payroll_details_controller_update_payroll_details')}>
                            Save
                        </button>
                    </div>
                </div>
            </form>

        );
    }
}

const mapStateToProps = (state) => {
    let value = {}
    let temp = state.profileManagement && state.profileManagement.profile && state.profileManagement.profile[0];

    if (temp && temp.payroll_details) {
        value = { ...value, id: temp.payroll_details.id, abn: temp.payroll_details.abn, tfn: temp.payroll_details.tfn }
    }

    for (let key in value) {
        if (value[key] === "null") {
            value[key] = null;
        }
    }

    return {
        formValues: state.form && state.form.PayrollDetailsForm &&
            state.form.PayrollDetailsForm.values ? state.form.PayrollDetailsForm.values : {},
        initialValues: (value ? value : ''),
        isDirty: isDirty('PayrollDetailsForm')(state),
        profileComplete: state.profileManagement && state.profileManagement.profileComplete
    }
}

const mapDispatchToprops = dispatch => {
    return {
        action: bindActionCreators(actions, dispatch),
    }
}

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToprops),
    reduxForm({
        form: 'PayrollDetailsForm', validate: pyrollDetailsValidation, enableReinitialize: true,
        onSubmitFail: (errors, dispatch, sub, props) => {
            handleFocus(errors, "#");
        }
    })
)(PayrollDetailsForm)